import { lazy } from 'solid-js'
import { messages } from '../../pages/whistler-vacation-rentals-page/whistler-vacation-rentals-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/whistler-vacation-rentals-page/whistler-vacation-rentals-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/whistler/vacation-rentals',
    titleMessage: messages.titleMessage,
}
